var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_pdf_file",
    "data-name": "ic pdf file",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect_157",
    "data-name": "Rect 157",
    width: 20,
    height: 20,
    transform: "translate(-11964 -1148)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf_file-2",
    "data-name": "ic pdf file",
    transform: "translate(11964 1148)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-11964 -1148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M2.5,0H13.121L18.75,5.608V18.75A1.25,1.25,0,0,1,17.5,20H2.5a1.25,1.25,0,0,1-1.25-1.25V1.25A1.25,1.25,0,0,1,2.5,0Z",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M18.732,5.625H14.375a1.25,1.25,0,0,1-1.25-1.25V.012Z",
    fill: "#b53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M14.061,9.477a.363.363,0,0,0,0-.719H12.869a.373.373,0,0,0-.363.406v2.931c0,.261.149.406.35.406s.349-.145.349-.406v-.8h.721a.339.339,0,0,0,.336-.365.332.332,0,0,0-.336-.355h-.721V9.477Zm-4.031-.719H9.158a.386.386,0,0,0-.405.4V12.1a.384.384,0,0,0,.415.393h.916a1.7,1.7,0,0,0,1.8-1.814A1.743,1.743,0,0,0,10.031,8.757Zm.042,3.009H9.541V9.481h.479c.726,0,1.041.487,1.041,1.159C11.061,11.269,10.751,11.766,10.073,11.766Zm-3.2-3.009H6.012a.363.363,0,0,0-.381.406v2.931a.368.368,0,1,0,.732,0v-.856h.542A1.183,1.183,0,0,0,8.126,10,1.2,1.2,0,0,0,6.876,8.757Zm-.014,1.794h-.5V9.446h.5a.555.555,0,0,1,0,1.106Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdfFile);
export default __webpack_public_path__ + "static/media/ic-pdf-file.822a181e4a181f1d49c1bd2be44f7349.svg";
export { ForwardRef as ReactComponent };